import { CHANGE_NETWORK, CLEAR_NETWORK } from 'state/network/constants'

export function changeNetwork(payload) {
  return { type: CHANGE_NETWORK, payload }
}

export function clearNetwork() {
  return { type: CLEAR_NETWORK }
}
